module.exports = __webpack_public_path__ + "static/media/close_day.1d629daf.svg";